exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.section-preview[data-v-1aa921f6] {\n  border: 1px solid #e0e0e0;\n  padding: 15px;\n}\n.datos-radicado[data-v-1aa921f6] {\n  display: flex;\n  justify-content: space-between;\n}\n.estilo_dos_columnas[data-v-1aa921f6] {\n  width: 50%;\n  margin-left: 5px;\n  margin-top: 5px;\n}\n.estilo_tres_columnas[data-v-1aa921f6] {\n  width: 33%;\n  padding-right: 10px;\n  padding-top: 15px;\n}\n", ""]);

// exports
